import { useLayer } from '@coursera-web/statsig';

import { useLocation } from 'js/lib/useRouter';

import { isTopAiProgramCategorySlug } from 'bundles/product-card/components/utils/copyTestUtils';
import { isEnterprisePathname } from 'bundles/product-card/utils/isEnterprisePathname';

export type TopAiProgramPillVariant = 'control' | 'gradient-background' | 'solid-background';

/**
 * Resolves the "Top AI program" pill variant for a product card. Only evaluates the Statsig
 * layer once the card is confirmed eligible (qualifying slug, consumer page), so ineligible
 * renders don't log a misleading exposure.
 */
export const useTopAiProgramPillVariant = (slug?: string): TopAiProgramPillVariant => {
  const location = useLocation();
  const layer = useLayer('product-card-ai-pill-color-treatment-layer');

  const isEligible = !!slug && isTopAiProgramCategorySlug(slug) && !isEnterprisePathname(location.pathname);

  if (!isEligible) {
    return 'control';
  }

  const variant = layer.get('Visual Design Variant', 'control');
  return variant === 'gradient-background' || variant === 'solid-background' ? variant : 'control';
};
